// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.vxe-toolbar[data-v-485643f6] {\r\n  padding-left: 0\n}\r\n", ""]);
// Exports
module.exports = exports;
